


export class CostReviewOperatorWorkstationSoftware {
  numberOfServers!: number;
  numberOfWorkstations!: number;
  numberOfClients!: number;
  competitorSystem!: string;
  internetAccessible!: number;
  featuresRequired!: string;
  aptUtilized!: number;
  numberOfPrograms!: number;
  numberOfGraphics!: number;
  centralizedGraphicsUtilized!: number;
  geccUtilized!: number;
  protocols!: number[];
  numberOfSwitches!: number;
  isOpWorksationsSoftwareApplicable!: boolean;
}
